<div *ngIf="data.headerEnabled" class="promo-top w-100 h-auto text-center theme-container"
    [style.backgroundImage]="'url(' + serverPath2 + data.headerLogoSrc + ')'"
    onerror="this.src='assets/images/notification-back.jpg';">
    <h4 [style.color]="data.headerBannerTextColour" class="font-weight-normal text-uppercase text-white m-0">
        {{data.headerNotificationContent}}</h4>
</div>

<div>
    <mat-toolbar *ngIf="display" class="top-bar" fxLayout="row" fxLayoutAlign="space-between center"
        style=" height: 40px; font-size: 14px; padding: 0 16px; position: fixed; top: 0; width: 100%; z-index: 1100;">

        <!-- Left links -->
        <div fxLayout="row" fxLayoutGap="10px" class="top-links">
            <span (click)="openPages()">Wishlist</span> | &#160;
            <span (click)="openPage()">Your Orders</span>
        </div>

        <!-- Center delivery text -->
        <span class="delivery-text">{{data.headerNotificationContent}}</span>

        <!-- Right language & contact -->
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" class="lang-currency">
            <span>Call Us:+ {{data.storePhoneNumber}}</span>
            <span *ngIf="languageSelection==1">| &#160;</span>
            <ng-container *ngIf="languageSelection==1">
                <calsoft-language style="color: black"></calsoft-language>
            </ng-container>
        </div>
    </mat-toolbar>

    <!-- ===================== MAIN HEADER ===================== -->
    <mat-toolbar *ngIf="display" class="header-v2 app-toolbar primary" fxHide fxShow.gt-md
        style="position: fixed; top: 40px; width: 100%; height: 100px; background-color: white; border-bottom: 1px solid #eee; z-index: 1090;"
        [class.active]="showFixedHeader" fxLayout="row" fxLayoutAlign="space-around center">

        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-around center" style="width: 100%; height: 100%;">

            <!-- Search -->
            <section fxFlex="27">
                <div *ngIf="data.disableSearchInHeader==0" class="search-bar" fxHide fxShow.gt-sm fxLayout="row"
                    fxLayoutAlign="start center" fxFlex fxFlex.gt-sm="300px">
                    <calsoft-search [scroll]="false" [design]="'2'"></calsoft-search>
                </div>
            </section>

            <!-- Logo -->
            <section fxFlex="40" fxLayout="row" fxLayoutAlign="center center" class="header-logo-section">
                <calsoft-logo [sitename]="data.siteName" [type]="'light'"></calsoft-logo>
            </section>

            <!-- Actions -->
            <section fxFlex="29" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
                <!-- Wishlist -->
                <button mat-button (click)="openPages()">
                    <mat-icon class="loginicon2">favorite_border</mat-icon>
                    <span class="logicon">&#160;Wishlist</span>
                </button>

                <!-- Login / Profile -->
                <ng-container *ngIf="data.disableLoginHeader==0">
                    <button *ngIf="!userLoggedIn" (click)="SignIn('login')" mat-button>
                        <div style="display:flex;">
                            <mat-icon class="loginicon">person</mat-icon>
                            <span class="logicon">&#160;Login</span>
                        </div>
                    </button>
                    <calsoft-HeaderUserProfileDropdown *ngIf="userLoggedIn" [data]="data" [design]="'2'"
                        class="headerUser">
                    </calsoft-HeaderUserProfileDropdown>
                </ng-container>

                <!-- Cart -->
                <calsoft-cart-icon [data]="data" [design]="'2'"></calsoft-cart-icon>
            </section>
        </mat-toolbar-row>
    </mat-toolbar>

    <!-- ===================== MENU BAR ===================== -->
    <mat-toolbar *ngIf="data.headerEnabled==0" fxHide fxShow.gt-md fxLayout="row" fxLayoutAlign="center center"
        style="margin-top: 140px; background-color: white; border-bottom: 1px solid #eee; z-index: 1000;">
        <mat-toolbar-row class="theme-container" fxLayoutAlign="center center">
            <calsoft-Menu [color]="false" [data]="data" [type]="'two'" [categoryArray]="item"></calsoft-Menu>
        </mat-toolbar-row>
    </mat-toolbar>


</div>

<div *ngIf="!display">

    <div *ngIf="mobileHeaderType==1">
        <calsoft-mobile-header [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header>
    </div>

    <div *ngIf="mobileHeaderType==0">
        <calsoft-mobile-header-new [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header-new>
    </div>

    <div *ngIf="mobileHeaderType==2">
        <calsoft-mobile-header3 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header3>
    </div>

    <div *ngIf="mobileHeaderType==3">
        <calsoft-mobile-header4 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header4>
    </div>

    <div *ngIf="mobileHeaderType==4">
        <calsoft-mobile-header5 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header5>
    </div>

    <div *ngIf="mobileHeaderType==5">
        <calsoft-mobile-header6 [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header6>
    </div>
    <div *ngIf="mobileHeaderType==6">
        <calsoft-mobile-header7 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header7>
    </div>
    <div *ngIf="mobileHeaderType==7">

        <calsoft-mobile-header8 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">

        </calsoft-mobile-header8>
    </div>
    <div *ngIf="mobileHeaderType==8">
        <calsoft-mobile-header9 [item]="item" [data]="data" [color]="'white'" [url]="url" [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header9>
    </div>
    <div *ngIf="mobileHeaderType==10">
        <calsoft-mobile-header11 [item]="item" [data]="data" [color]="'white'" [url]="url"
            [userLoggedIn]="userLoggedIn">
        </calsoft-mobile-header11>
    </div>
</div>